import {withClassNames} from 'quickstart/theme'
import * as B from '../block'
import S from './styles.module.css'

export const Heading = B.H3

export const NumberedHeading = withClassNames(S['numbered-heading'])(Heading)

export const BorderedStack = withClassNames(S['bordered-stack'])(B.Stack)

export const ButtonStack = withClassNames(S['button-stack'])(B.Stack)
